// extracted by mini-css-extract-plugin
export default {"bilal":"style_bilal__ubf2-","loadingOverlay":"style_loadingOverlay__VxbZ4","loadingContent":"style_loadingContent__SUPwY","spinner":"style_spinner__Ro8Ld","spin":"style_spin__L0g9Y"};